import { MENU_TYPE } from '@/model/components/menu/sideMenuType'
import { Screen } from './stateScreen'

// ヘッダー表示情報
type HeaderDisp = {
  username: boolean
  lang: boolean
  help: boolean
  logout: boolean
  menu: boolean
}

// ヘッダー情報
type Header = {
  // 表示情報
  disp: HeaderDisp
  // 設定言語
  language: string
}

// メニュー情報
type Menu = {
  // 現在選択箇所
  selected: MENU_TYPE
}

// ログイン情報
type Login = {
  // ログイン状態
  status: boolean
  // ユーザー名
  username: string
  // ユーザー表示名
  usernamedisp: string
  // CSRFトークン
  csrftoken: string
}

// 状態
type State = {
  header: Header
  login: Login
  menu: Menu
  screen: Screen
  other: boolean
}

// stateの初期値
const state: State = {
  header: {
    disp: {
      username: false,
      lang: true,
      help: true,
      logout: false,
      menu: false,
    },
    language: '',
  },
  login: {
    status: false,
    username: '',
    usernamedisp: '',
    csrftoken: '',
  },
  menu: {
    selected: MENU_TYPE.DOWNLOAD,
  },
  other: false,
  screen: {
    top: {
      username: '',
      auth: true,
      error: { data: [] },
    },
    download: {
      search: false,
      detail: {
        key: '',
        senddate: '',
        from: '',
        subject: '',
        size: 0,
        attached: [],
        dispAttached: false,
        dispEml: false,
        isFail: false,
      },
      error: { data: [] },
    },
  },
}
export { State, state, Login, Screen }
